import { createFileRoute } from '@tanstack/react-router';

import { requireAuth } from '@/app/lib/auth-guard';
import { AutomaticPaymentsPage } from '@/billing/pages/automatic-payments';

export const Route = createFileRoute('/billing/automatic-payments/')({
  beforeLoad: async (ctx) => {
    await requireAuth(ctx);
  },
  component: AutomaticPaymentsRoute,
  staticData: {
    headerSection: 'billing'
  }
});

function AutomaticPaymentsRoute() {
  return <AutomaticPaymentsPage />;
}
